import React, { useState, useEffect } from 'react';
import PageHeader from '../../../components/PageHeader';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import FourthStep from './FourthStep';
import { Form, Button, notification, Row, Col, Skeleton } from 'antd';
import { useNavigate } from 'react-router-dom';
import 'antd/dist/antd.min.css';
import moment from 'moment';
import * as quickReportService from '../../../services/createQuickReport';
import * as getReportService from '../../../services/SingleReport';
import * as getClientdropService from '../../../services/getClientdrop';
import * as createClientService from '../../../services/AllClients';
import { useDispatch, useSelector } from 'react-redux';
import { CheckCircleOutlined, FilePdfOutlined } from '@ant-design/icons';
import ReportSpin from '../../../components/ReportSpinner';
import useAutosave from '../../../hooks/useAutosave';
import AutosaveIndicator from '../../../components/AutosaveIndicator';
import * as AutosaveService from '../../../services/autosaveService';
import { flattenNestedArrays } from '../../../utils/arrayFlattener';
import { updateLaminateReport, resetLaminateReport } from '../../../store/actions/laminateReport';

const LaminateUpdate = () => {
  var dispatch = useDispatch();
  let navigate = useNavigate();
  const reportData = useSelector((state) => state.laminateReport.data);
  const reqId = useSelector((state) => state.Inspection.reqId);
  const [loading, setLoading] = useState(false);
  const [clientDropdown, setclientDropdown] = useState([]);
  const [manufDropdown, setmanufDropdown] = useState([]);
  const [dealerDropdown, setdealerDropdown] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [SpinnerReport, setSpinnerReport] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [footerLogo, setFooterLogo] = useState([]);
  const [subDivision, setSubDivision] = useState([{ gc_subdivision: '' }]);
  const [lotNumber, setLotNumber] = useState([{ gc_lotnumber: '' }]);
  const [calOpen, setCalOpen] = useState(false);
  const [calOpen1, setCalOpen1] = useState(false);
  const [calOpen2, setCalOpen2] = useState(false);
  const [calOpen3, setCalOpen3] = useState(false);
  const [calOpen4, setCalOpen4] = useState(false);
  const [calOpen5, setCalOpen5] = useState(false);
  const [calOpen6, setCalOpen6] = useState(false);
  const [calOpen7, setCalOpen7] = useState(false);
  const [calOpen8, setCalOpen8] = useState(false);
  const [calOpen9, setCalOpen9] = useState(false);
  const [isOpen, setIsOpen] = useState({
    commPartyopen: false,
    installationOther: false,
    installationGlue: false,
    buildingOther: false,
    buildingStyleOther: false,
    vacummBrandOther: false,
    footprintOther: false,
    cushionOther: false,
    foundationField: false,
    crawalField: false,
    slabField: false,
    basementField: false,
    trafficTypeOther: false,
    exteriorOther: false,
    subFloorOther: false,
    constructionField: false,
    walkField: false,
    buildField: false,
    curlingDomingMeasurementField: false,
    cleanedField: false,
    proCleanedField: false,
    sendingSampleField: true,
    claimHistoryField: true,
    observationField: true,
    applicableField: true,
    industryField: true,
    conclusionField: true,
    causeField: false,
    confidentialField: false,
    signatureField: false,
    footerField: false,
    notesField: false,
    floorOtherField: false,
    heatingField: false,
    acField: false,
    airOnField: false,
    underlayField: false,
    nounderlayField: false,
    humidifierField: false,
    dehumidifierField: false,
    manuissuesField: true,
    siteissuesField: true,
    perfoissuesField: true,
    instaissuesField: true,
  });

  const [values, setValues] = useState(reportData);

  // useEffect(() => {
  //   dispatch(updateLaminateReport(values));
  // }, [values, dispatch]);

  const [autosaveEnabled, setAutosaveEnabled] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const report_id = queryParams.get('report_id');
  const isEditMode = Boolean(report_id);

  const transformValuesForAutosave = (values) => {
    const transformedValues = { ...values };
    let subbb = [];
    transformedValues.activeStep = activeStep;
    subDivision.forEach((subd) => (subbb = [...subbb, subd.gc_subdivision]));
    transformedValues.gc_subdivision = subbb;
    let lot = [];
    lotNumber.forEach((lotNum) => (lot = [...lot, lotNum.gc_lotnumber]));
    transformedValues.gc_lotnumber = lot;
    transformedValues.req_id = reqId.req_id;
    transformedValues.category = reqId.floor_category;
    // transformedValues.total_claim_qt_unit = transformedValues?.measure_type1;
    // transformedValues.total_affected_unit = transformedValues?.measure_type2;
    transformedValues.curling_doming_measurement =
      transformedValues.curling_doming_measurement === true ? 'yes' : 'no';

    transformedValues.res_attic_stock = transformedValues.res_attic_stock === true ? 'yes' : 'no';

    transformedValues.car_tog_plastic = transformedValues.car_tog_plastic === true ? 'yes' : 'no';
    transformedValues.res_attic_stock = transformedValues.res_attic_stock === true ? 'yes' : 'no';

  transformedValues.claim_his_togg = (transformedValues.claim_his_togg === true || transformedValues.claim_his_togg === 'yes' || transformedValues.claim_his_togg === '1') ? 'yes' : 'no';
    transformedValues.observe_togg = (transformedValues.observe_togg === true || transformedValues.observe_togg === 'yes' || transformedValues.observe_togg === '1') ? 'yes' : 'no';
    transformedValues.app_field_togg = (transformedValues.app_field_togg === true || transformedValues.app_field_togg === 'yes' || transformedValues.app_field_togg === '1') ? 'yes' : 'no';
    transformedValues.indus_stand_togg = (transformedValues.indus_stand_togg === true || transformedValues.indus_stand_togg === 'yes' || transformedValues.indus_stand_togg === '1') ? 'yes' : 'no';
    transformedValues.conc_togg = (transformedValues.conc_togg === true || transformedValues.conc_togg === 'yes' || transformedValues.conc_togg === '1') ? 'yes' : 'no';
    transformedValues.cause_togg = (transformedValues.cause_togg === true || transformedValues.cause_togg === 'yes' || transformedValues.cause_togg === '1') ? 'yes' : 'no';
    transformedValues.manufacturing_issue_togg = (transformedValues.manufacturing_issue_togg === true || transformedValues.manufacturing_issue_togg === 'yes' || transformedValues.manufacturing_issue_togg === '1') ? 'yes' : 'no';
    transformedValues.site_rel_issue_togg = (transformedValues.site_rel_issue_togg === true || transformedValues.site_rel_issue_togg === 'yes' || transformedValues.site_rel_issue_togg === '1') ? 'yes' : 'no';
    transformedValues.perfo_rel_issue_togg = (transformedValues.perfo_rel_issue_togg === true || transformedValues.perfo_rel_issue_togg === 'yes' || transformedValues.perfo_rel_issue_togg === '1') ? 'yes' : 'no';
    transformedValues.insta_rel_issue_togg = (transformedValues.insta_rel_issue_togg === true || transformedValues.insta_rel_issue_togg === 'yes' || transformedValues.insta_rel_issue_togg === '1') ? 'yes' : 'no';
    transformedValues.confi = (transformedValues.confi === true || transformedValues.confi === 'yes' || transformedValues.confi === '1') ? 'yes' : 'no';
    transformedValues.upload_sign_toggle = (transformedValues.upload_sign_toggle === true || transformedValues.upload_sign_toggle === 'yes' || transformedValues.upload_sign_toggle === '1') ? 'yes' : 'no';
    transformedValues.footer_text_info = (transformedValues.footer_text_info === true || transformedValues.footer_text_info === 'yes' || transformedValues.footer_text_info === '1') ? 'yes' : 'no';
    transformedValues.private_notes_togg = (transformedValues.private_notes_togg === true || transformedValues.private_notes_togg === 'yes' || transformedValues.private_notes_togg === '1') ? 'yes' : 'no';
    transformedValues.footer_info_toggle = (transformedValues.footer_info_toggle === true || transformedValues.footer_info_toggle === 'yes' || transformedValues.footer_info_toggle === '1') ? 'yes' : 'no';
    transformedValues.party_toggle = transformedValues.stepOneTogg?.includes('1') ? 'yes' : 'no';
    transformedValues.enduser_toggle = transformedValues.stepOneTogg?.includes('2') ? 'yes' : 'no';
    transformedValues.mc_info_toggle = transformedValues.stepOneTogg?.includes('3') ? 'yes' : 'no';
    transformedValues.dealer_info_toggle = transformedValues.stepOneTogg?.includes('4')
      ? 'yes'
      : 'no';
    transformedValues.gc_info_toggle = transformedValues.stepOneTogg?.includes('5') ? 'yes' : 'no';
    transformedValues.basic_info_toggle = transformedValues.stepOneTogg?.includes('6') ? 'yes' : 'no';
    transformedValues.site_info_toggle = transformedValues.stepOneTogg?.includes('7') ? 'yes' : 'no';
    transformedValues.installer_info_toggle = transformedValues.stepOneTogg?.includes('8') ? 'yes' : 'no';
    transformedValues.interior_info_toggle = transformedValues.stepThreeTogg?.includes('1')
      ? 'yes'
      : 'no';
    transformedValues.moisture_info = transformedValues.stepThreeTogg?.includes('2') ? 'yes' : 'no';
    transformedValues.floor_mois_info = transformedValues.stepThreeTogg?.includes('3') ? 'yes' : 'no';
    transformedValues.subtrace_toggle = transformedValues.stepThreeTogg?.includes('4') ? 'yes' : 'no';
    transformedValues.obser_info_toggle = transformedValues.stepFourTogg?.includes('6')
      ? 'yes'
      : 'no';
    transformedValues.issues_info_toggle = transformedValues.stepFourTogg?.includes('10')
      ? 'yes'
      : 'no';
    //transformedValues.confi = transformedValues.stepFourTogg?.includes("7") ? "yes" : "no";
    transformedValues.footer_info_toggle = transformedValues.stepFourTogg?.includes('8')
      ? 'yes'
      : 'no';
    return transformedValues;
  };

  const { status, error } = useAutosave(
    values,
    (data) => quickReportService.updateQuickReport(transformValuesForAutosave(data)),
    { enabled: autosaveEnabled }
  );

  const takefileList = (list) => {
    dispatch(updateLaminateReport({ attachments: list }));
  };

  useEffect(() => {
    setLoading(true);
    dispatch(resetLaminateReport());
    fetchclientData();
    getReportData();
    fetchmanufData();
    fetchdealerData();
    window.scrollTo(0, 0);
    AutosaveService.getAutosaveSetting()
      .then(res => {
        if (res.data && res.data.enabled !== undefined) {
          setAutosaveEnabled(res.data.enabled);
        }
      })
      .catch(err => {
        console.error("Error fetching autosave setting", err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValues(reportData);
    if (reportData?.footprint === 'Other') {
      setIsOpen((prev) => ({ ...prev, footprintOther: true }));
    }
  }, [reportData]);

  const handleServiceChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...subDivision];
    list[index][name] = value;
    setSubDivision(list);
    console.warn('subDivision', subDivision);
  };

  const handleServiceRemove = (index) => {
    const list = [...subDivision];
    list.splice(index, 1);
    setSubDivision(list);
  };

  const handleServiceAdd = () => {
    setSubDivision([...subDivision, { gc_subdivision: '' }]);
  };

  const handleLotChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...lotNumber];
    list[index][name] = value;
    setLotNumber(list);
    console.warn('lotNumber', lotNumber);
  };

  const handleLotRemove = (index) => {
    const list = [...lotNumber];
    list.splice(index, 1);
    setLotNumber(list);
  };

  const handleLotAdd = () => {
    setLotNumber([...lotNumber, { gc_lotnumber: '' }]);
  };

  const getReportData = () => {
    setLoading(true);
    dispatch(getReportService.getSingleReport(report_id))
      .then((res) => {
        let reportRes = res;
        setActiveStep(
          parseInt(reportRes.activeStep) ? parseInt(reportRes.activeStep) : 0
        );

        reportRes.installer_present =
          reportRes?.installer_present === 'yes' || reportRes?.installer_present === 'Yes' ? 'Yes' : reportRes?.installer_present;
        reportRes.balance_toggle =
          reportRes?.balance_toggle === 'yes' || reportRes?.balance_toggle === 'Yes' ? 'Yes' : reportRes?.balance_toggle;
        reportRes.flooring_installed_toggle =
          reportRes?.flooring_installed_toggle === 'yes' || reportRes?.flooring_installed_toggle === 'Yes' ? 'Yes' : reportRes?.flooring_installed_toggle;
        reportRes.floor_rolled_toggle =
          reportRes?.floor_rolled_toggle === 'yes' || reportRes?.floor_rolled_toggle === 'Yes' ? 'Yes' : reportRes?.floor_rolled_toggle;
        reportRes.items_obstruct =
          reportRes?.items_obstruct === 'yes' || reportRes?.items_obstruct === 'Yes' ? 'Yes' : reportRes?.items_obstruct;
        reportRes.fasteners_applied =
          reportRes?.fasteners_applied === 'yes' || reportRes?.fasteners_applied === 'Yes' ? 'Yes' : reportRes?.fasteners_applied;
        reportRes.fast_floor =
          reportRes?.fast_floor === 'yes' || reportRes?.fast_floor === 'Yes' ? 'Yes' : reportRes?.fast_floor;
        reportRes.evident_floor =
          reportRes?.evident_floor === 'yes' || reportRes?.evident_floor === 'Yes' ? 'Yes' : reportRes?.evident_floor;
        reportRes.vertical_delection =
          reportRes?.vertical_delection === 'yes' || reportRes?.vertical_delection === 'Yes' ? 'Yes' : reportRes?.vertical_delection;
        reportRes.adjoining_rooms =
          reportRes?.adjoining_rooms === 'yes' || reportRes?.adjoining_rooms === 'Yes' ? 'Yes' : reportRes?.adjoining_rooms;
        reportRes.doorways_togg =
          reportRes?.doorways_togg === 'yes' || reportRes?.doorways_togg === 'Yes' ? 'Yes' : reportRes?.doorways_togg;
        reportRes.acc_normal_liv =
          reportRes?.acc_normal_liv === 'yes' || reportRes?.acc_normal_liv === 'Yes' ? 'Yes' : reportRes?.acc_normal_liv;
        reportRes.do_it_yourself =
          reportRes?.do_it_yourself === 'yes' || reportRes?.do_it_yourself === 'Yes' ? 'Yes' : reportRes?.do_it_yourself;
        reportRes.heat =
          reportRes?.heat === 'yes' || reportRes?.heat === 'Yes' ? 'Yes' : reportRes?.heat;
        reportRes.airon =
          reportRes?.airon === 'yes' || reportRes?.airon === 'Yes' ? 'Yes' : reportRes?.airon;
        reportRes.car_tog_grade =
          reportRes?.car_tog_grade === 'yes' || reportRes?.car_tog_grade === 'Yes' ? 'Yes' : reportRes?.car_tog_grade;
        reportRes.car_tog_alkali =
          reportRes?.car_tog_alkali === 'yes' || reportRes?.car_tog_alkali === 'Yes' ? 'Yes' : reportRes?.car_tog_alkali;
        reportRes.car_tog_cross =
          reportRes?.car_tog_cross === 'yes' || reportRes?.car_tog_cross === 'Yes' ? 'Yes' : reportRes?.car_tog_cross;
        reportRes.car_tog_joist =
          reportRes?.car_tog_joist === 'yes' || reportRes?.car_tog_joist === 'Yes' ? 'Yes' : reportRes?.car_tog_joist;
        reportRes.car_tog_mold =
          reportRes?.car_tog_mold === 'yes' || reportRes?.car_tog_mold === 'Yes' ? 'Yes' : reportRes?.car_tog_mold;
        reportRes.car_tog_water =
          reportRes?.car_tog_water === 'yes' || reportRes?.car_tog_water === 'Yes' ? 'Yes' : reportRes?.car_tog_water;
        reportRes.no_underlayment_install =
          reportRes?.no_underlayment_install === 'yes' || reportRes?.no_underlayment_install === 'Yes' ? 'Yes' : reportRes?.no_underlayment_install;

        reportRes.h_bui_occupied =
          reportRes?.h_bui_occupied === 'yes' || reportRes?.h_bui_occupied === 'Yes' ? 'Yes' : reportRes?.h_bui_occupied;
        reportRes.h_bui_walk_off =
          reportRes?.h_bui_walk_off === 'yes' || reportRes?.h_bui_walk_off === 'Yes' ? 'Yes' : reportRes?.h_bui_walk_off;
        reportRes.h_bui_cons =
          reportRes?.h_bui_cons === 'yes' || reportRes?.h_bui_cons === 'Yes' ? 'Yes' : reportRes?.h_bui_cons;
        reportRes.cleaned =
          reportRes?.cleaned === 'yes' || reportRes?.cleaned === 'Yes' ? 'Yes' : reportRes?.cleaned;
        reportRes.professinally_cleaned =
          reportRes?.professinally_cleaned === 'yes' || reportRes?.professinally_cleaned === 'Yes' ? 'Yes' : reportRes?.professinally_cleaned;
        reportRes.i2_product_ins =
          reportRes?.i2_product_ins === 'yes' || reportRes?.i2_product_ins === 'Yes' ? 'Yes' : reportRes?.i2_product_ins;
        reportRes.humidifier =
          reportRes?.humidifier === 'yes' || reportRes?.humidifier === 'Yes' ? 'Yes' : reportRes?.humidifier;
        reportRes.dehumidifier =
          reportRes?.dehumidifier === 'yes' || reportRes?.dehumidifier === 'Yes' ? 'Yes' : reportRes?.dehumidifier;
        reportRes.underlay_user =
          reportRes?.underlay_user === 'yes' || reportRes?.underlay_user === 'Yes' ? 'Yes' : reportRes?.underlay_user;
        reportRes.sending_samples =
          reportRes?.sending_samples === 'yes' || reportRes?.sending_samples === 'Yes' ? 'Yes' : reportRes?.sending_samples;
        reportRes.car_tog_wall =
          reportRes?.car_tog_wall === 'yes' || reportRes?.car_tog_wall === 'Yes' ? 'Yes' : reportRes?.car_tog_wall;
        reportRes.car_tog_paint =
          reportRes?.car_tog_paint === 'yes' || reportRes?.car_tog_paint === 'Yes' ? 'Yes' : reportRes?.car_tog_paint;
        reportRes.car_tog_floor =
          reportRes?.car_tog_floor === 'yes' || reportRes?.car_tog_floor === 'Yes' ? 'Yes' : reportRes?.car_tog_floor;
        reportRes.car_tog_vented =
          reportRes?.car_tog_vented === 'yes' || reportRes?.car_tog_vented === 'Yes' ? 'Yes' : reportRes?.car_tog_vented;
        reportRes.car_tog_rusty =
          reportRes?.car_tog_rusty === 'yes' || reportRes?.car_tog_rusty === 'Yes' ? 'Yes' : reportRes?.car_tog_rusty;
        reportRes.car_tog_finish =
          reportRes?.car_tog_finish === 'yes' || reportRes?.car_tog_finish === 'Yes' ? 'Yes' : reportRes?.car_tog_finish;
        reportRes.car_tog_insulated =
          reportRes?.car_tog_insulated === 'yes' || reportRes?.car_tog_insulated === 'Yes' ? 'Yes' : reportRes?.car_tog_insulated;
        reportRes.mois_test = reportRes?.mois_test === 'yes' || reportRes?.mois_test === 'Yes' ? 'Yes' : reportRes?.mois_test;
        reportRes.measure_type1 = reportRes?.total_claim_qt_unit;
        reportRes.measure_type2 = reportRes?.total_affected_unit;
        reportRes.curling_doming_measurement =
          reportRes?.curling_doming_measurement === 'yes' ? true : false;
        reportRes.cause_togg = (reportRes?.cause_togg === 'yes' || reportRes?.cause_togg === '1' || reportRes?.cause_togg === true);
        reportRes.manufacturing_issue_togg = (reportRes?.manufacturing_issue_togg === 'yes' || reportRes?.manufacturing_issue_togg === '1' || reportRes?.manufacturing_issue_togg === true);
        reportRes.site_rel_issue_togg = (reportRes?.site_rel_issue_togg === 'yes' || reportRes?.site_rel_issue_togg === '1' || reportRes?.site_rel_issue_togg === true);
        reportRes.insta_rel_issue_togg = (reportRes?.insta_rel_issue_togg === 'yes' || reportRes?.insta_rel_issue_togg === '1' || reportRes?.insta_rel_issue_togg === true);
        reportRes.perfo_rel_issue_togg = (reportRes?.perfo_rel_issue_togg === 'yes' || reportRes?.perfo_rel_issue_togg === '1' || reportRes?.perfo_rel_issue_togg === true);
        setIsOpen({
          ...isOpen,
          manuissuesField: reportRes.manufacturing_issue_togg,
          siteissuesField: reportRes.site_rel_issue_togg,
          instaissuesField: reportRes.insta_rel_issue_togg,
          perfoissuesField: reportRes.perfo_rel_issue_togg,
        });
        reportRes.claim_his_togg =
          (reportRes?.claim_his_togg === 'yes' || reportRes?.claim_his_togg === '1' || reportRes?.claim_his_togg === true);
        reportRes.observe_togg =
          (reportRes?.observe_togg === 'yes' || reportRes?.observe_togg === '1' || reportRes?.observe_togg === true);
        reportRes.app_field_togg =
          (reportRes?.app_field_togg === 'yes' || reportRes?.app_field_togg === '1' || reportRes?.app_field_togg === true);
        reportRes.indus_stand_togg =
          (reportRes?.indus_stand_togg === 'yes' || reportRes?.indus_stand_togg === '1' || reportRes?.indus_stand_togg === true);
        reportRes.conc_togg = (reportRes?.conc_togg === 'yes' || reportRes?.conc_togg === '1' || reportRes?.conc_togg === true);
        reportRes.upload_sign_toggle =
          (reportRes?.upload_sign_toggle === 'yes' || reportRes?.upload_sign_toggle === '1' || reportRes?.upload_sign_toggle === true);

        reportRes.car_tog_plastic =
          reportRes?.car_tog_plastic === 'yes' ? true : false;
        reportRes.footer_text_info =
          (reportRes?.footer_text_info === 'yes' || reportRes?.footer_text_info === '1' || reportRes?.footer_text_info === true);
        reportRes.footer_info_toggle =
          (reportRes?.footer_info_toggle === 'yes' || reportRes?.footer_info_toggle === '1' || reportRes?.footer_info_toggle === true);
        reportRes.obser_info_toggle =
          reportRes?.obser_info_toggle === 'yes' ? true : false;
        reportRes.issues_info_toggle =
          (reportRes?.issues_info_toggle === 'yes' || reportRes?.issues_info_toggle === '1' || reportRes?.issues_info_toggle === true);
        reportRes.confi = (reportRes?.confi === 'yes' || reportRes?.confi === '1' || reportRes?.confi === true);
        reportRes.private_notes_togg =
          (reportRes?.private_notes_togg === 'yes' || reportRes?.private_notes_togg === '1' || reportRes?.private_notes_togg === true);
        let data1 = [];
        if (reportRes.attachments) {
          Object.keys(reportRes.attachments).forEach(function (key, index) {
            data1.push(reportRes.attachments[key]);
          });
        }
        reportRes.attachments = data1;
        let Allimagedescription = {};
        reportRes.attachments.forEach((attachment) => {
          let indexVal = String(attachment['uid']);
          Allimagedescription[indexVal] = {};
          Allimagedescription[indexVal]['caption'] = attachment['desc'];
        });
        reportRes.Allimagedescription = Allimagedescription;
        flattenNestedArrays(
          reportRes,
          ['1', '2', '3', '4', '5', '6', '7', '8'],
          ['1', '2', '3', '4'],
          ['6', '7', '8', '10']
        );

        if (
          reportRes?.gc_lotnumber[0] &&
          reportRes?.gc_lotnumber[0][0] !== ''
        ) {
          let lotNumber = [];
          reportRes.gc_lotnumber[0].map((lotnumb) => {
            return lotNumber.push({ gc_lotnumber: lotnumb });
          });
          setLotNumber(lotNumber);
        }

        if (
          reportRes?.gc_subdivision[0] &&
          reportRes?.gc_subdivision[0][0] !== ''
        ) {
          let subDivision = [];
          reportRes.gc_subdivision[0].map((subDiv) => {
            return subDivision.push({ gc_subdivision: subDiv });
          });
          setSubDivision(subDivision);
        }

        //footerlogos
        let newlogos = [];
        // console.warn('response quick reports', typeof(res.selectededlogos))

        if (reportRes.selectededlogos) {
          Object.keys(reportRes.selectededlogos) &&
            Object.keys(reportRes.selectededlogos).forEach(function (
              key,
              index
            ) {
              newlogos.push(reportRes.selectededlogos[key].id?.toString());
            });
          //setselectedLogos(newlogos)
          reportRes.footerLogo = newlogos;
          setFooterLogo(newlogos);
        }
        if (reportRes.disable_conclusion) {
          reportRes.conclusion_text = "The commissioning party has requested that the inspection report provide factual and technical information, which will be used with other manufacturer’s data, including product development, product history, warranty, installation, and care & maintenance information for this claim’s determination and final disposition. The manufacturer will use the information to determine if the claim is manufacturing-related or related to non-manufacturing issues.";
        }
        // setValues(reportRes);
        dispatch(updateLaminateReport(reportRes));
        setLoading(false);
        console.info('Report Data Get', reportRes);
      })
      .catch((err) => {
        // alert("error",err);
        // Extract and display a meaningful error message
        let errorMessage;

        if (err.response) {
          // The request was made and the server responded with a status code outside of the 2xx range
          errorMessage = `Error ${err.response.status}: ${err.response.data?.message || err.response.statusText || 'Unknown Error'}`;
        } else if (err.request) {
          // The request was made but no response was received
          errorMessage = "No response received from the server. Please check your network connection.";
        } else {
          // Something else happened while setting up the request
          errorMessage = `An unexpected error occurred: ${err.message}`;
        }

        // Display the error message in an alert or use a UI notification component
        alert(errorMessage);
      });
  };

  const fetchclientData = (params = {}) => {
    dispatch(getClientdropService.getClientdrop())
      .then((res) => {
        setclientDropdown(res);
      })
      .catch((err) => {
        console.info('Get Error Edit State...');
      });
  };
  const fetchmanufData = (params = {}) => {
    dispatch(getClientdropService.getManufdrop())
      .then((res) => {
        setmanufDropdown(res);
      })
      .catch((err) => {
        console.info('Get Error Edit State...');
      });
  };
  const fetchdealerData = (params = {}) => {
    dispatch(getClientdropService.getDealerdrop())
      .then((res) => {
        setdealerDropdown(res);
      })
      .catch((err) => {
        console.info('Get Error Edit State...');
      });
  };

  function getStepContent(steps) {
    switch (steps) {
      case 0:
        return (
          <FirstStep
            handleChange={handleChange}
            handleFill={handleFill}
            values={values}
            loading={loading}
            isOpen={isOpen}
            addClient={addClient}
            clientDropdown={clientDropdown}
            manufDropdown={manufDropdown}
            dealerDropdown={dealerDropdown}
            subDivision={subDivision}
            handleServiceChange={handleServiceChange}
            handleServiceAdd={handleServiceAdd}
            handleServiceRemove={handleServiceRemove}
            lotNumber={lotNumber}
            handleLotChange={handleLotChange}
            handleLotAdd={handleLotAdd}
            handleLotRemove={handleLotRemove}
            handleDateformate={handleDateformate}
            calOpen={calOpen}
            setCalOpen={setCalOpen}
            calOpen1={calOpen1}
            setCalOpen1={setCalOpen1}
            calOpen2={calOpen2}
            setCalOpen2={setCalOpen2}
            calOpen3={calOpen3}
            setCalOpen3={setCalOpen3}
            calOpen4={calOpen4}
            setCalOpen4={setCalOpen4}
            calOpen5={calOpen5}
            setCalOpen5={setCalOpen5}
            calOpen7={calOpen7}
            setCalOpen7={setCalOpen7}
            calOpen8={calOpen8}
            setCalOpen8={setCalOpen8}
            calOpen9={calOpen9}
            setCalOpen9={setCalOpen9}
            editMode={isEditMode}
          />
        );
      case 1:
        return (
          <SecondStep
            handleChange={handleChange}
            values={values}
            isOpen={isOpen}
            editMode={isEditMode}
          />
        );
      case 2:
        return (
          <ThirdStep
            handleChange={handleChange}
            values={values}
            isOpen={isOpen}
            editMode={isEditMode}
          />
        );
      case 3:
        return (
          <FourthStep
            handleChange={handleChange}
            handleEditor={handleEditor}
            values={values}
            isOpen={isOpen}
            handleDateformate={handleDateformate}
            calOpen6={calOpen6}
            setCalOpen6={setCalOpen6}
            setLoadings={setLoadings}
            editMode={isEditMode}
            takefileList={takefileList}
            handleFill={handleFill}

          />
        );
      default:
        return <FirstStep handleChange={handleChange} values={values} editMode={isEditMode}/>;
    }
  }

  function getSteps() {
    return [
      'GENERAL',
      'HISTORY AND MAINTENANCE',
      'INDOOR ENVIRONMENT',
      'OBSERVATION & COMMENTS',
    ];
  }

  const steps = getSteps();

  const onFinish = () => {
    setLoadings(true);

    let subbb = [];
    values.activeStep = activeStep;
    subDivision.forEach((subd) => (subbb = [...subbb, subd.gc_subdivision]));
    values.gc_subdivision = subbb;
    let lot = [];
    lotNumber.forEach((lotNum) => (lot = [...lot, lotNum.gc_lotnumber]));
    values.gc_lotnumber = lot;
    values.req_id = reqId.req_id;
    values.category = reqId.floor_category;
    values.total_claim_qt_unit = values?.measure_type1;
    values.total_affected_unit = values?.measure_type2;
    values.curling_doming_measurement =
      values.curling_doming_measurement === true ? 'yes' : 'no';

    values.res_attic_stock = values.res_attic_stock === true ? 'yes' : 'no';

    values.car_tog_plastic = values.car_tog_plastic === true ? 'yes' : 'no';
    values.res_attic_stock = values.res_attic_stock === true ? 'yes' : 'no';

    values.claim_his_togg = (values.claim_his_togg === true || values.claim_his_togg === 'yes' || values.claim_his_togg === '1') ? 'yes' : 'no';
    values.observe_togg = (values.observe_togg === true || values.observe_togg === 'yes' || values.observe_togg === '1') ? 'yes' : 'no';
    values.app_field_togg = (values.app_field_togg === true || values.app_field_togg === 'yes' || values.app_field_togg === '1') ? 'yes' : 'no';
    values.indus_stand_togg = (values.indus_stand_togg === true || values.indus_stand_togg === 'yes' || values.indus_stand_togg === '1') ? 'yes' : 'no';
    values.conc_togg = (values.conc_togg === true || values.conc_togg === 'yes' || values.conc_togg === '1') ? 'yes' : 'no';
    values.cause_togg = (values.cause_togg === true || values.cause_togg === 'yes' || values.cause_togg === '1') ? 'yes' : 'no';
    values.manufacturing_issue_togg = (values.manufacturing_issue_togg === true || values.manufacturing_issue_togg === 'yes' || values.manufacturing_issue_togg === '1') ? 'yes' : 'no';
    values.site_rel_issue_togg = (values.site_rel_issue_togg === true || values.site_rel_issue_togg === 'yes' || values.site_rel_issue_togg === '1') ? 'yes' : 'no';
    values.perfo_rel_issue_togg = (values.perfo_rel_issue_togg === true || values.perfo_rel_issue_togg === 'yes' || values.perfo_rel_issue_togg === '1') ? 'yes' : 'no';
    values.insta_rel_issue_togg = (values.insta_rel_issue_togg === true || values.insta_rel_issue_togg === 'yes' || values.insta_rel_issue_togg === '1') ? 'yes' : 'no';
    values.confi = (values.confi === true || values.confi === 'yes' || values.confi === '1') ? 'yes' : 'no';
    values.upload_sign_toggle =
      (values.upload_sign_toggle === true || values.upload_sign_toggle === 'yes' || values.upload_sign_toggle === '1') ? 'yes' : 'no';
    values.footer_text_info = (values.footer_text_info === true || values.footer_text_info === 'yes' || values.footer_text_info === '1') ? 'yes' : 'no';
    values.private_notes_togg =
      (values.private_notes_togg === true || values.private_notes_togg === 'yes' || values.private_notes_togg === '1') ? 'yes' : 'no';
    values.footer_info_toggle =
      (values.footer_info_toggle === true || values.footer_info_toggle === 'yes' || values.footer_info_toggle === '1') ? 'yes' : 'no';
    values.party_toggle = values.stepOneTogg?.includes('1') ? 'yes' : 'no';
    values.enduser_toggle = values.stepOneTogg?.includes('2') ? 'yes' : 'no';
    values.mc_info_toggle = values.stepOneTogg?.includes('3') ? 'yes' : 'no';
    values.dealer_info_toggle = values.stepOneTogg?.includes('4')
      ? 'yes'
      : 'no';
    values.gc_info_toggle = values.stepOneTogg?.includes('5') ? 'yes' : 'no';
    values.basic_info_toggle = values.stepOneTogg?.includes('6') ? 'yes' : 'no';
    values.site_info_toggle = values.stepOneTogg?.includes('7') ? 'yes' : 'no';
    values.installer_info_toggle = values.stepOneTogg?.includes('8') ? 'yes' : 'no';
    values.interior_info_toggle = values.stepThreeTogg?.includes('1')
      ? 'yes'
      : 'no';
    values.moisture_info = values.stepThreeTogg?.includes('2') ? 'yes' : 'no';
    values.floor_mois_info = values.stepThreeTogg?.includes('3') ? 'yes' : 'no';
    values.subtrace_toggle = values.stepThreeTogg?.includes('4') ? 'yes' : 'no';
    values.obser_info_toggle = values.stepFourTogg?.includes('6')
      ? 'yes'
      : 'no';
    values.issues_info_toggle = values.stepFourTogg?.includes('10')
      ? 'yes'
      : 'no';
    //values.confi = values.stepFourTogg?.includes("7") ? "yes" : "no";
    values.footer_info_toggle = values.stepFourTogg?.includes('8')
      ? 'yes'
      : 'no';


  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleNext = () => {
    window.scrollTo(0, 0);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    window.scrollTo(0, 0);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const addClient = () => {
    console.warn('addClient', values);
    let clientData = {
      company_name_qr: values.company_name_qr,
      comm_party_drop: values.comm_party_drop,
      agent_claim_name: values.agent_claim_name,
      comm_email: values.comm_email,
      street_name_number: values.street_name_number,
      state: values.state,
      city: values.city,
      country: values.country,
      zip_code: values.zip_code,
      phone_no_party: values.phone_no_party,
    };
    if (clientData.company_name_qr !== '' && clientData.comm_email !== '') {
      dispatch(createClientService.create_client(clientData))
        .then((res) => {
          console.warn('createClientService', res);
          if (res.status === 'client added') {
            fetchclientData();
            notification.success({
              message: 'Client successfully created!',
              description: 'You have successfully created a client.',
            });
          } else {
            fetchclientData();
            notification.error({
              message: `${res.status}`,
              description:
                'The client that you are trying to create already exists.”',
              className: 'custom-class',
            });
          }
        })
        .catch((err) => {
          console.info('Get Error Edit State...', loading);
          notification.error('This is an error message');
          setLoading(false);
        });
    } else {
      notification.error('Client data is not valid');
    }
  };

  const handleChange = (input) => (e) => {
    const newValues = { ...values };
    console.warn('Event on select', input, e);
    console.warn('isOpen', isOpen);
    if (
      input === 'comm_party_drop' ||
      input === 'inspection_type' ||
      input === 'property_dropdown' ||
      input === 'grade' ||
      input === 'footprint' ||
      input === 'building_landscape' ||
      input === 'joist_type' ||
      input === 'flooring_type' ||
      input === 'car_i2_inst_type' ||
      input === 'building_type' ||
      input === 'building_style' ||
      input === 'vacumm_brand' ||
      input === 'cushion_dropdown' ||
      input === 'foundation' ||
      input === 'traffic_type' ||
      input === 'i2_product_ins' ||
      input === 'all_exterior' ||
      input === 'curling_doming_measurement' ||
      input === 'heating_system' ||
      input === 'air_conditioning' ||
      input === 'subfloor_type' ||
      input === 'h_bui_cons' ||
      input === 'h_bui_walk_off' ||
      input === 'humidifier' ||
      input === 'dehumidifier' ||
      input === 'h_bui_occupied' ||
      input === 'cleaned' ||
      input === 'professinally_cleaned' ||
      input === 'do_it_yourself' ||
      input === 'res_attic_stock' ||
      input === 'sending_samples' ||
      input === 'claim_his_togg' ||
      input === 'observe_togg' ||
      input === 'app_field_togg' ||
      input === 'indus_stand_togg' ||
      input === 'conc_togg' ||
      input === 'cause_togg' ||
      input === 'manufacturing_issue_togg' ||
      input === 'site_rel_issue_togg' ||
      input === 'insta_rel_issue_togg' ||
      input === 'perfo_rel_issue_togg' ||
      input === 'confi' ||
      input === 'upload_sign_toggle' ||
      input === 'footer_text_info' ||
      input === 'private_notes_togg' ||
      input === 'footer_info_toggle' ||
      input === 'floor_rolled_toggle' ||
      input === 'installer_present' ||
      input === 'balance_toggle' ||
      input === 'heat' ||
      input === 'airon' ||
      input === 'car_tog_alkali' ||
      input === 'car_tog_grade' ||
      input === 'car_tog_cross' ||
      input === 'car_tog_joist' ||
      input === 'car_tog_mold' ||
      input === 'car_tog_water' ||
      input === 'underlay_user' ||
      input === 'no_underlayment_install' ||
      input === 'acc_normal_liv' ||
      input === 'flooring_installed_toggle' ||
      input === 'items_obstruct' ||
      input === 'fasteners_applied' ||
      input === 'fast_floor' ||
      input === 'evident_floor' ||
      input === 'vertical_delection' ||
      input === 'adjoining_rooms' ||
      input === 'doorways_togg' ||
      input === 'car_tog_plastic' ||
      input === 'car_tog_wall' ||
      input === 'car_tog_paint' ||
      input === 'car_tog_floor' ||
      input === 'car_tog_vented' ||
      input === 'car_tog_rusty' ||
      input === 'car_tog_finish' ||
      input === 'car_tog_insulated' ||
      input === 'mois_test'
    ) {
      if (input === 'inspection_type') {
        newValues[input] = e;
      }
      if (input === 'grade') {
        newValues[input] = e;
      }
      if (input === 'footprint' && e === 'Other') {
        setIsOpen({ ...isOpen, footprintOther: true });
        newValues[input] = e;
      } else if (input === 'footprint' && e !== 'Other') {
        setIsOpen({ ...isOpen, footprintOther: false });
        newValues[input] = e;
      }
      if (input === 'building_landscape') {
        newValues[input] = e;
      }
      if (input === 'joist_type') {
        newValues[input] = e;
      }
      if (input === 'property_dropdown') {
        newValues[input] = e;
      }
      if (input === 'car_tog_wall') {
        newValues[input] = e;
      }
      if (input === 'car_tog_paint') {
        newValues[input] = e;
      }
      if (input === 'car_tog_floor') {
        newValues[input] = e;
      }
      if (input === 'car_tog_vented') {
        newValues[input] = e;
      }
      if (input === 'car_tog_rusty') {
        newValues[input] = e;
      }
      if (input === 'car_tog_finish') {
        newValues[input] = e;
      }
      if (input === 'car_tog_insulated') {
        newValues[input] = e;
      }
      if (input === 'mois_test') {
        newValues[input] = e;
      }
      if (input === 'comm_party_drop' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          commPartyopen: true,
        });
        newValues[input] = e;
      } else if (input === 'comm_party_drop' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          commPartyopen: false,
        });
        newValues[input] = e;
      }

      if (input === 'items_obstruct') {
        newValues[input] = e;
      }
      if (input === 'fasteners_applied') {
        newValues[input] = e;
      }
      if (input === 'fast_floor') {
        newValues[input] = e;
      }
      if (input === 'evident_floor') {
        newValues[input] = e;
      }
      if (input === 'vertical_delection') {
        newValues[input] = e;
      }
      if (input === 'adjoining_rooms') {
        newValues[input] = e;
      }
      if (input === 'doorways_togg') {
        newValues[input] = e;
      }

      if (input === 'cleaned') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            cleanedField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            cleanedField: false,
          });
          newValues[input] = e;
        }
      }

      if (input === 'professinally_cleaned') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            proCleanedField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            proCleanedField: false,
          });
          newValues[input] = e;
        }

      }
      if (input === 'do_it_yourself') {
        newValues[input] = e;
      }




      if (input === 'floor_rolled_toggle') {
        newValues[input] = e;
      }
      if (input === 'installer_present') {
        newValues[input] = e;
      }

      if (input === 'balance_toggle') {
        newValues[input] = e;
      }
      if (input === 'flooring_installed_toggle') {
        newValues[input] = e;
      }
      if (input === 'h_bui_occupied') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            buildField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            buildField: false,
          });
          newValues[input] = e;
        }

      }

      if (input === 'h_bui_walk_off') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            walkField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            walkField: false,
          });
          newValues[input] = e;
        }

      }
      if (input === 'h_bui_cons') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            constructionField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            constructionField: false,
          });
          newValues[input] = e;
        }
      }

      if (input === 'humidifier') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            humidifierField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            humidifierField: false,
          });
          newValues[input] = e;
        }

      }
      if (input === 'dehumidifier') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            dehumidifierField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            dehumidifierField: false,
          });
          newValues[input] = e;
        }

      }
      if (input === 'acc_normal_liv') {
        newValues[input] = e;
      }
      if (input === 'heat') {
        newValues[input] = e;
      }
      if (input === 'airon') {
        newValues[input] = e;
      }
      if (input === 'car_tog_alkali') {
        newValues[input] = e;
      }
      if (input === 'car_tog_grade') {
        newValues[input] = e;
      }
      if (input === 'car_tog_cross') {
        newValues[input] = e;
      }
      if (input === 'car_tog_joist') {
        newValues[input] = e;
      }
      if (input === 'car_tog_mold') {
        newValues[input] = e;
      }
      if (input === 'car_tog_water') {
        newValues[input] = e;
      }
      if (input === 'underlay_user') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            underlayField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            underlayField: false,
          });
          newValues[input] = e;
        }
      }

      if (input === 'no_underlayment_install') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            nounderlayField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            nounderlayField: false,
          });
          newValues[input] = e;
        }
      }
      if (input === 'flooring_type' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          floorOtherField: true,
        });
        newValues[input] = e;
      } else if (input === 'flooring_type' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          floorOtherField: false,
        });
        newValues[input] = e;
      }

      if (input === 'car_i2_inst_type' && e === 'Glue down') {
        setIsOpen({
          ...isOpen,
          installationGlue: true,
          installationOther: false,
        });
        newValues[input] = e;
      } else if (input === 'car_i2_inst_type' && e !== 'Glue down') {
        setIsOpen({
          ...isOpen,
          installationGlue: false,
        });
        newValues[input] = e;
      }
      if (input === 'car_i2_inst_type' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          installationGlue: false,
          installationOther: true,
        });
        newValues[input] = e;
      } else if (input === 'car_i2_inst_type' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          installationOther: false,
        });
        newValues[input] = e;
      }
      if (input === 'building_type' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          buildingOther: true,
        });
        newValues[input] = e;
      } else if (input === 'building_type' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          buildingOther: false,
        });
        newValues[input] = e;
      }
      if (input === 'curling_doming_measurement' && e === true) {
        setIsOpen({
          ...isOpen,
          curlingDomingMeasurementField: true,
        });
        newValues[input] = e;
      } else if (input === 'curling_doming_measurement' && e === false) {
        setIsOpen({
          ...isOpen,
          curlingDomingMeasurementField: false,
        });
        newValues[input] = e;
      }

      if (input === 'building_style' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          buildingStyleOther: true,
        });
        newValues[input] = e;
      } else if (input === 'building_style' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          buildingStyleOther: false,
        });
        newValues[input] = e;
      }

      if (input === 'vacumm_brand' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          vacummBrandOther: true,
        });
        newValues[input] = e;
      } else if (input === 'vacumm_brand' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          vacummBrandOther: false,
        });
        newValues[input] = e;
      }

      if (input === 'cushion_dropdown' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          cushionOther: true,
        });
        newValues[input] = e;
      } else if (input === 'cushion_dropdown' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          cushionOther: false,
        });
        newValues[input] = e;
      }
      // Product Installed
      if (input === 'i2_product_ins') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            productField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            productField: false,
          });
          newValues[input] = e;
        }

      }

      if (
        input === 'foundation' &&
        (e === 'Foundation' || e === 'Crawlspace')
      ) {
        setIsOpen({
          ...isOpen,
          foundationField: true,
          basementField: false,
          slabField: false,
        });
        newValues[input] = e;
      } else if (input === 'foundation' && e === 'Basement') {
        setIsOpen({
          ...isOpen,
          foundationField: false,
          basementField: true,
          slabField: false,
        });
        newValues[input] = e;
      } else if (input === 'foundation' && e === 'Slab') {
        setIsOpen({
          ...isOpen,
          foundationField: false,
          basementField: false,
          slabField: true,
        });
        newValues[input] = e;
      } else if (input === 'foundation' && e === 'Basement/Crawl Space') {
        setIsOpen({
          ...isOpen,
          foundationField: false,
          basementField: true,
          slabField: false,
        });
        newValues[input] = e;
      }

      if (input === 'traffic_type' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          trafficTypeOther: true,
        });
        newValues[input] = e;
      } else if (input === 'traffic_type' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          trafficTypeOther: false,
        });
        newValues[input] = e;
      }

      if (input === 'all_exterior' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          exteriorOther: true,
        });
        newValues[input] = e;
      } else if (input === 'all_exterior' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          exteriorOther: false,
        });
        newValues[input] = e;
      }

      if (input === 'subfloor_type' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          subFloorOther: true,
        });
        newValues[input] = e;
      } else if (input === 'subfloor_type' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          subFloorOther: false,
        });
        newValues[input] = e;
      }

      if (input === 'heating_system' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          heatingField: true,
        });
        newValues[input] = e;
      } else if (input === 'heating_system' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          heatingField: false,
        });
        newValues[input] = e;
      }

      if (input === 'air_conditioning' && e === 'Other') {
        setIsOpen({
          ...isOpen,
          acField: true,
        });
        newValues[input] = e;
      } else if (input === 'air_conditioning' && e !== 'Other') {
        setIsOpen({
          ...isOpen,
          acField: false,
        });
        newValues[input] = e;
      }


      if (input === 'res_attic_stock' && e === true) {
        setIsOpen({
          ...isOpen,
          atticStockField: true,
        });
        newValues[input] = e;
      } else if (input === 'res_attic_stock' && e === false) {
        setIsOpen({
          ...isOpen,
          atticStockField: false,
        });
        newValues[input] = e;
      }

      if (input === 'sending_samples') {
        if (e === 'Yes') {
          setIsOpen({
            ...isOpen,
            sendingSampleField: true,
          });
          newValues[input] = e;
        } else if (e === 'HideThisField' || e === 'No') {
          setIsOpen({
            ...isOpen,
            sendingSampleField: false,
          });
          newValues[input] = e;
        }

      }

      if (input === 'claim_his_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          claimHistoryField: true,
        });
        newValues[input] = e;
      } else if (input === 'claim_his_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          claimHistoryField: false,
        });
        newValues[input] = e;
      }

      if (input === 'observe_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          observationField: true,
        });
        newValues[input] = e;
      } else if (input === 'observe_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          observationField: false,
        });
        newValues[input] = e;
      }

      if (input === 'app_field_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          applicableField: true,
        });
        newValues[input] = e;
      } else if (input === 'app_field_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          applicableField: false,
        });
        newValues[input] = e;
      }

      if (input === 'indus_stand_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          industryField: true,
        });
        newValues[input] = e;
      } else if (input === 'indus_stand_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          industryField: false,
        });
        newValues[input] = e;
      }

      if (input === 'conc_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          conclusionField: true,
        });
        newValues[input] = e;
      } else if (input === 'conc_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          conclusionField: false,
        });
        newValues[input] = e;
      }

      if (input === 'cause_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          causeField: true,
        });
        newValues[input] = e;
      } else if (input === 'cause_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          causeField: false,
        });
        newValues[input] = e;
      }
      if (input === 'manufacturing_issue_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          manuissuesField: true,
        });
        newValues[input] = e;
      } else if (input === 'manufacturing_issue_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          manuissuesField: false,
        });
        newValues[input] = e;
      }
      if (input === 'site_rel_issue_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          siteissuesField: true,
        });
        newValues[input] = e;
      } else if (input === 'site_rel_issue_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          siteissuesField: false,
        });
        newValues[input] = e;
      }
      if (input === 'perfo_rel_issue_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          perfoissuesField: true,
        });
        newValues[input] = e;
      } else if (input === 'perfo_rel_issue_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          perfoissuesField: false,
        });
        newValues[input] = e;
      }
      if (input === 'insta_rel_issue_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          instaissuesField: true,
        });
        newValues[input] = e;
      } else if (input === 'insta_rel_issue_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          instaissuesField: false,
        });
        newValues[input] = e;
      }
      if (input === 'confi' && e === true) {
        setIsOpen({
          ...isOpen,
          confidentialField: true,
        });
        newValues[input] = e;
      } else if (input === 'confi' && e === false) {
        setIsOpen({
          ...isOpen,
          confidentialField: false,
        });
        newValues[input] = e;
      }

      if (input === 'upload_sign_toggle' && e === true) {
        setIsOpen({
          ...isOpen,
          signatureField: true,
        });
        newValues[input] = e;
      } else if (input === 'upload_sign_toggle' && e === false) {
        setIsOpen({
          ...isOpen,
          signatureField: false,
        });
        newValues[input] = e;
      }

      if (input === 'footer_text_info' && e === true) {
        setIsOpen({
          ...isOpen,
          footerField: true,
        });
        newValues[input] = e;
      } else if (input === 'footer_text_info' && e === false) {
        setIsOpen({
          ...isOpen,
          footerField: false,
        });
        newValues[input] = e;
      }

      if (input === 'private_notes_togg' && e === true) {
        setIsOpen({
          ...isOpen,
          notesField: true,
        });
        newValues[input] = e;
      } else if (input === 'private_notes_togg' && e === false) {
        setIsOpen({
          ...isOpen,
          notesField: false,
        });
        newValues[input] = e;
      }
    } else if (
      input === 'inspection_type' ||
      input === 'client_select_drop' ||
      input === 'fiber_type' ||
      input === 'time_type' ||
      input === 'measure_type1' ||
      input === 'measure_type2' ||
      input === 'client_select_drop' ||
      input === 'property_dropdown' ||
      input === 'building_type' ||
      input === 'building_style' ||
      input === 'traffic_type' ||
      input === 'vacumm_brand' ||
      input === 'vacumm_condition' ||
      input === 'vacum_cleaner' ||
      input === 'vacum_worker' ||
      input === 'cri_seal' ||

      input === 'foundation' ||
      input === 'grade' ||
      input === 'footprint' ||
      input === 'building_landscape' ||
      input === 'subfloor_type' ||
      input === 'car_i2_inst_type' ||
      input === 'cushion_dropdown' ||
      input === 'manuf_resuse_drop' ||
      input === 'dealer_resuse_drop' ||
      input === 'cleaner_brush' ||
      input === 'vacumm' ||
      input === 'heating_system' ||
      input === 'air_conditioning' ||
      input === 'all_exterior' ||
      input === 'stepOneTogg' ||
      input === 'stepThreeTogg' ||
      input === 'stepFourTogg' ||

      input === 'joist_type'

    ) 
    {
      if(input === 'time_type' && e !== undefined){
        newValues[input] = e[0] 
      } else if (input === 'measure_type1') {
        if (e !== undefined) {
          newValues[input] = e[0];
          newValues['total_claim_qt_unit'] = e[0];
        } else {
          newValues[input] = '';
          newValues['total_claim_qt_unit'] = '';
        }
      } else if (input === 'measure_type2') {
        if (e !== undefined) {
          newValues[input] = e[0];
          newValues['total_affected_unit'] = e[0];
        } else {
          newValues[input] = '';
          newValues['total_affected_unit'] = '';
        }
      } else {
        newValues[input] = e;
      }
    } 
  else if (
      input === 'h_bi_ins_date' ||
      input === 'product_date_of_ins' ||
      input === 'date_problem_noticed' ||
      input === 'closing_date' ||
      input === 'moving_date' ||
      input === 'date_shipped' ||
      input === 'date_home' ||
      input === 'date_hvac' ||
      input === 'site_occupied_date' ||
      input === 'operational_date'
    ) {
      let date = moment(e).format('MM-DD-YYYY');
      newValues[input] = date;
    } else if (input === 'footerLogo') {
      //start
      let footerlogo1 = [];
      let id = e.target.value;
      footerlogo1 = [...footerLogo];
      if (footerlogo1?.includes(id)) {
        let footer_idex = footerlogo1.indexOf(id);
        delete footerlogo1[footer_idex];
      } else {
        footerlogo1.push(id);
      }
      footerlogo1 = footerlogo1?.filter((e) => e);
      setFooterLogo(footerlogo1);
      newValues.footerLogo = footerlogo1;
    } else {
      newValues[input] = e.target.value;
    }
    dispatch(updateLaminateReport(newValues));
  };

  const handleEditor = (valEditor, label) => {
      // const newValues = { ...values, [label]: valEditor };
      const newValues = { [label]: valEditor };
      dispatch(updateLaminateReport(newValues));
  };

  const handleFill = (val) => {
       const newValues = { ...values, ...val };
       dispatch(updateLaminateReport(newValues));
  };

  const saveDraft = () => {
    setSpinnerReport(true);
    values.status = 'Saved';
    onFinish();
    setLoading(true);
    dispatch(quickReportService.updateQuickReport(values))
      .then((res) => {
        console.warn('Submit', res);
        setSpinnerReport(false);
        window.location.reload(false);
        navigate('/laminate-update/?report_id=' + res.data.report_id);
        setLoading(false);
      })
      .catch((err) => {
        // Extract and display a meaningful error message
        let errorMessage;

        if (err.response) {
          // The request was made and the server responded with a status code outside of the 2xx range
          errorMessage = `Error ${err.response.status}: ${err.response.data?.message || err.response.statusText || 'Unknown Error'}`;
        } else if (err.request) {
          // The request was made but no response was received
          errorMessage = "No response received from the server. Please check your network connection.";
        } else {
          // Something else happened while setting up the request
          errorMessage = `An unexpected error occurred: ${err.message}`;
        }

        // Display the error message in an alert or use a UI notification component
        alert(errorMessage);
      });
  };

  const buttonSubmit = () => {
    setSpinnerReport(true);
    values.status = 'Saved';
    onFinish();
    dispatch(quickReportService.updateQuickReport(values))
      .then((res) => {
        console.warn('Submit', res);
        notification.open({
          message: 'Report successfully updated!',
          description: 'You have successfully updated a report.',
          icon: (
            <CheckCircleOutlined
              style={{
                color: '#108ee9',
              }}
            />
          ),
        });
        //return;
        setSpinnerReport(false);
        navigate('/single-laminate/?report_id=' + res.data.report_id);
      })
      .catch((err) => {
        // Extract and display a meaningful error message
        let errorMessage;

        if (err.response) {
   
          // The request was made and the server responded with a status code outside of the 2xx range
          errorMessage = `Error ${err.response.status}: ${err.response.data?.message || err.response.statusText || 'Unknown Error'}`;
        } else if (err.request) {
          // The request was made but no response was received
          errorMessage = "No response received from the server. Please check your network connection.";
        } else {
          // Something else happened while setting up the request
          errorMessage = `An unexpected error occurred: ${err.message}`;
        }

        // Display the error message in an alert or use a UI notification component
        alert(errorMessage);
      });
  };

  const handleDateformate = (e, name, type) => {
    console.log('ok', e);
    if (name === 'h_bi_ins_date') {
      if (type === 'date') {
        setCalOpen(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'product_date_of_ins') {
      if (type === 'date') {
        setCalOpen1(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'date_problem_noticed') {
      if (type === 'date') {
        setCalOpen2(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'closing_date') {
      if (type === 'date') {
        setCalOpen3(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'moving_date') {
      if (type === 'date') {
        setCalOpen4(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'operational_date') {
      if (type === 'date') {
        setCalOpen5(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'date_shipped') {
      if (type === 'date') {
        setCalOpen6(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'date_home') {
      if (type === 'date') {
        setCalOpen7(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'date_hvac') {
      if (type === 'date') {
        setCalOpen8(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    if (name === 'site_occupied_date') {
      if (type === 'date') {
        setCalOpen9(false);
        let date = moment(e).format('MM-DD-YYYY');
        const newValues = { ...values, [name]: date };
        dispatch(updateLaminateReport(newValues));
        console.log('date', date);
      } else {
        let value = e.target.value;
        const newValues = { ...values, [name]: value };
        dispatch(updateLaminateReport(newValues));
      }
    }
    console.info('arra', e, name, type);
  };

const handleNavigate = () => {
    window.open(
      '//www.floordetective.com/wp-content/uploads/2021/09/Laminate-Blank.pdf',
      '_blank'
    );
  };

  return (
    <>
      {SpinnerReport ? (
        <ReportSpin />
      ) : (
        <>
          <div className="quickReportWrapper ">
            <div className="pageHeader ">
              <PageHeader title="Laminate" />
            </div>
            {loading ? (
              <div className="container-xxl">
                <div className="Skeleton_space">
                  <Row gutter={16} className="mb-3" justify="center">
                    <Col xs={24} md={6} xl={6} className="sklpad">
                      <Skeleton.Button
                        active
                        size="large"
                        shape="circle"
                        block={false}
                        className="abccc"
                      />
                      <Skeleton.Input
                        active
                        size="large"
                        block={false}
                        className="abccd"
                      />
                    </Col>
                    <Col xs={24} md={6} xl={6} className="sklpad">
                      <Skeleton.Button
                        active
                        size="large"
                        shape="circle"
                        block={false}
                        className="abccc"
                      />
                      <Skeleton.Input
                        active
                        size="large"
                        block={false}
                        className="abccd"
                      />
                    </Col>
                    <Col xs={24} md={6} xl={6} className="sklpad">
                      <Skeleton.Button
                        active
                        size="large"
                        shape="circle"
                        block={false}
                        className="abccc"
                      />
                      <Skeleton.Input
                        active
                        size="large"
                        block={false}
                        className="abccd"
                      />
                    </Col>
                    <Col xs={24} md={6} xl={6} className="sklpad">
                      <Skeleton.Button
                        active
                        size="large"
                        shape="circle"
                        block={false}
                        className="abccc"
                      />
                      <Skeleton.Input
                        active
                        size="large"
                        block={false}
                        className="abccd"
                      />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-3">
                    <Col md={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                  </Row>
                </div>
              </div>
            ) : (
              <div>
                 <div className="buttonSection">
                  <div className="container-xxl">
                    <Row>
                      <Col xs={24} md={24} className="text-end">
                        <Button
                          type="success"
                          className="btn inspectionAdd"
                          onClick={() => handleNavigate()}
                          icon={<FilePdfOutlined />}
                        >
                          Print Form
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              <div className="container-xxl CarpetDetailed">
                <div className="reportInner">
                  <Box sx={{ my: 5 }}>
                    <div>
                      <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        nonLinear
                      >
                        {steps.map((label, index) => (
                          <Step key={label} className="cusutom-stepp">
                            <StepButton
                              color="inherit"
                              onClick={handleStep(index)}
                            >
                              {label}
                            </StepButton>
                          </Step>
                        ))}
                      </Stepper>
                    </div>
                  </Box>
                  <Form
                    name="basic"
                    labelCol={{
                      span: 8,
                    }}
                    wrapperCol={{
                      span: 16,
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    className="custom-form"
                  >
                    <div className="step-content">
                      {getStepContent(activeStep)}
                      <div className="custum-btngrp">
                        <Button
                          className="nxtbtn"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          Back
                        </Button>
                        {activeStep === steps.length - 1 ? (
                          <Button
                            onClick={() => buttonSubmit()}
                            className="submitBtn"
                            loading={loadings}
                          >
                            Save And Continue To Preview Report
                          </Button>
                        ) : (
                          <Button
                            className="custom-nxtbtn"
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                          >
                            Next
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form>
                </div>
                  {!autosaveEnabled && (
                        <div className="saveDraftBtn">
                          <Button
                            className="float floatBtn sc_button_hover_fade"
                            id="draft"
                            name="update_button"
                            onClick={() => saveDraft()}
                            disabled={loadings}
                          >
                            Save Draft
                          </Button>
                        </div>
                      )}
                      {autosaveEnabled && (
                        <AutosaveIndicator status={status} error={error} floating />
                )}
              </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default LaminateUpdate;

